import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "right-sidebar-modal"
}
const _hoisted_2 = { class: "right-sidebar-modal__container" }
const _hoisted_3 = { class: "right-sidebar-modal__header flex middle-xs" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "medium black" }
const _hoisted_7 = { class: "right-sidebar-modal__content" }

import { onMounted, onBeforeUnmount, watchEffect } from 'vue';
  import SectionComponent from './SectionComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RightSidebarModalComponent',
  props: {
    modalName: {
      type: String,
      default: 'info',
    },
    title: {
      type: String,
      default: '',
    },
    state: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['setState'],
  setup(__props, { emit }) {

const props = __props

  

  

  const toggleSidebar = (value: boolean, removeHash: boolean = true) => {
    if (value) {
      document.body.classList.add('hidden');
    } else {
      document.body.classList.remove('hidden');
      emit('setState', false);
    }
  };

  const close = () => {
    toggleSidebar(false);
  };

  const hashChangeHandler = (event: Event) => {
    const oldHash = (event as any).oldURL.split('#')[1];
    if (oldHash && oldHash === props.modalName) {
      toggleSidebar(false, false);
    }
  };

  onMounted(() => {
    window.addEventListener('hashchange', hashChangeHandler);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('hashchange', hashChangeHandler);
  });

  watchEffect(() => {
    toggleSidebar(props.state);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "sidebar" }, {
    default: _withCtx(() => [
      (__props.state)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "right-sidebar-modal__background",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
            }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_openBlock(), _createElementBlock("svg", {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                }, _hoisted_5)),
                _createElementVNode("p", _hoisted_6, _toDisplayString(__props.title), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(SectionComponent, null, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})